"use strict";
exports.__esModule = true;
exports.defaultGoogleMapState = {
    center: {
        lat: 22.285512,
        lng: 114.1403064
    },
    zoom: 16
};
